// FE-PINV-065 — REST client for the SavedView surface.
//
// Five endpoints under ``/api/v1/sales/pipeline-saved-views/``:
//
//   GET  /                — list
//   POST /                — create (409 on duplicate name)
//   PATCH /{id}/          — partial update
//   DELETE /{id}/         — soft-delete
//   POST /{id}/pin/       — atomic pin-as-default
//
// The BE seeds a "My pipeline" default per (entity, owner) on
// membership creation; the list endpoint always returns at least
// that row.

import { api } from "@/api/client";

import type {
  CreateSavedViewPayload,
  PatchSavedViewPayload,
  SavedView,
  SavedViewListResponse,
} from "./savedViewTypes";


export function fetchSavedViews(
  opts?: { signal?: AbortSignal },
): Promise<SavedViewListResponse> {
  return api.get<SavedViewListResponse>(
    "/api/v1/sales/pipeline-saved-views/", opts,
  );
}


export function createSavedView(
  payload: CreateSavedViewPayload,
): Promise<SavedView> {
  return api.post<SavedView>(
    "/api/v1/sales/pipeline-saved-views/", payload,
  );
}


export function patchSavedView(
  id: string, payload: PatchSavedViewPayload,
): Promise<SavedView> {
  return api.patch<SavedView>(
    `/api/v1/sales/pipeline-saved-views/${id}/`, payload,
  );
}


export function deleteSavedView(id: string): Promise<void> {
  return api.delete<void>(
    `/api/v1/sales/pipeline-saved-views/${id}/`,
  );
}


export function pinSavedView(id: string): Promise<SavedView> {
  return api.post<SavedView>(
    `/api/v1/sales/pipeline-saved-views/${id}/pin/`, {},
  );
}
